import { useEffect, useState } from 'react';
import { apiAuthMe, apiResendVerifyEmail } from '../lib/api';
import { useNavigate } from 'react-router-dom';

export default function VerifyEmail() {
  const nav = useNavigate();
  const [notice, setNotice] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);

  async function check() {
    setChecking(true);
    try {
      const res = await apiAuthMe();
      if (res?.user?.email_verified_at) {
        nav('/dashboard');
      }
    } catch {
      // ignore
    } finally {
      setChecking(false);
    }
  }

  useEffect(() => {
    check();
    const t = setInterval(check, 3000);
    return () => clearInterval(t);
  }, []); // eslint-disable-line

  async function onResend() {
    setError(null);
    setNotice(null);
    try {
      const res = await apiResendVerifyEmail();
      setNotice(res?.message || 'Verification link sent.');
    } catch (err: any) {
      setError(err?.data?.message || err.message || 'Could not resend verification');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-6">
      <div className="w-full max-w-lg bg-white dark:bg-gray-800 rounded-2xl shadow p-6">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Verify your email</h1>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
          We’ve sent a verification link to your email. Click it to verify. This page will auto-detect when you’re verified.
        </p>

        {notice && (
          <div className="mb-4 rounded-lg border border-green-200 bg-green-50 text-green-700 p-3 text-sm">
            {notice}
          </div>
        )}
        {error && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 text-red-700 p-3 text-sm">
            {error}
          </div>
        )}

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onResend}
            className="inline-flex items-center justify-center rounded-md bg-blue-600 text-white px-4 py-2 text-sm font-medium hover:bg-blue-700"
          >
            Resend verification email
          </button>
          <button
            type="button"
            onClick={check}
            disabled={checking}
            className="inline-flex items-center justify-center rounded-md border border-gray-300 dark:border-gray-600 px-4 py-2 text-sm text-gray-700 dark:text-gray-100 disabled:opacity-60"
          >
            {checking ? 'Checking…' : 'I’ve verified'}
          </button>
        </div>
      </div>
    </div>
  );
}
